import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useInvoiceQuery } from '../../../api/gql';
import { UpdateAmountDueModule } from '../../../modules/dialogs/update-amount';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';

export const InvoiceUpdateAmountPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Unexpected - route variable :invoiceId is missing.');
  }

  return (
    <UpdateAmountDueModule
      invoiceId={invoiceId}
      transNs={'page-invoice-update-amount'}
      onSuccess={({ setDueAmount }) => {
        queryClient.setQueryData(useInvoiceQuery.getKey({ id: setDueAmount.id }), {
          invoice: { ...setDueAmount },
        });
        safeNavigate(`/invoice/${setDueAmount.id}`);
      }}
    />
  );
};
